import type { Money } from 'shared/util/money';

export interface AmendedPricePreview {
    bookingValue: Money;
    serviceFee: Money;
    fullPayment: Money;
}

export const parseAmendedPricePreview = (data: Record<string, unknown>): AmendedPricePreview => {
    const bookingValue = data.bookingValue as Money;
    const serviceFee = data.serviceFee as Money;
    const fullPayment = data.fullPayment as Money;
    const amendedPricePreview: Partial<AmendedPricePreview> = {
        bookingValue: {
            value: bookingValue.value,
            currency: bookingValue.currency,
        },
        serviceFee: {
            value: serviceFee.value,
            currency: serviceFee.currency,
        },
        fullPayment: {
            value: fullPayment.value,
            currency: fullPayment.currency,
        },
    };
    return {
        ...(amendedPricePreview as AmendedPricePreview),
    };
};
